
/**
 * Copyright (c) Platform Science Inc. All rights reserved.
 */

import { getItem, setItem, removeItem } from '../../util/localStorage';

export const previousPageLocalStorageKey = 'PreviousPageLocation';
export const codeVerifierKey = 'vcode';
export const providerHostKey = 'providerHost';

const user: {
  accessToken: string,
  accessTokenExpiration: string,
  idToken: string,
  providerHost: string,
} = {
  accessToken: '',
  accessTokenExpiration: '',
  idToken: '',
  providerHost: '',
};

/**
 * Get the current user access token.
 */
export function getAccessToken() {
  return user.accessToken;
}

/**
 * Get the ID token.
 */
export function getIdToken() {
  return user.idToken;
}

/**
 * Set the user access token.
 *
 * @param {string} token
 */
export function setAccessToken(token: string) {
  user.accessToken = token;
}

/**
 * Set the ID token.
 *
 * @param {string} idToken
 */
export function setIdToken(idToken: string) {
  user.idToken = idToken;
}

/**
 * Get the provided expiration date for the user accesstoken.
 */
export function getAccessTokenExpiration() {
  return user.accessTokenExpiration;
}

/**
 * Set the provided expiration date for the user accesstoken.
 *
 * @param {string} expirationDateTime
 */
export function setAccessTokenExpiration(expirationDateTime: string) {
  user.accessTokenExpiration = expirationDateTime;
}

/**
 * Get the provider host that was used for authentication.
 */
export function getProviderHostUsedForAuth() {
  if (user.providerHost) {
    return user.providerHost;
  }
  
  const storedHost = getItem(providerHostKey);
  if (storedHost) {
    user.providerHost = storedHost;
    return storedHost;
  }
  
  return '';
}

/**
 * Set the provider host that was used for authentication.
 * This should be called during login to ensure logout uses the correct provider.
 *
 * @param {string} providerHost
 */
export function setProviderHostUsedForAuth(providerHost: string) {
  user.providerHost = providerHost;
  setItem(providerHostKey, providerHost);
}

/**
 * Clear the stored provider host (called during logout)
 */
export function clearProviderHostUsedForAuth() {
  user.providerHost = '';
  removeItem(providerHostKey);
}

export const localStorageKeys = {
  codeVerifierKey,
  previousPageLocalStorageKey,
  providerHostKey,
};
